import { CmsImage, CmsLink } from 'src/types'
import * as Styles from './VideoImages.style'
import Image from 'src/components/atoms/Image/Image'
import { Title } from 'src/components/atoms/Title/Title'
import RichText from 'src/components/atoms/RichText/RichText'
import { Link } from 'react-router-dom'
import Text from 'src/components/atoms/Text/Text'
import { useResponsive } from 'ahooks'

type VideoImagesProps = {
    images: CmsImage[]
    video: string
    content: string
    link?: CmsLink
}

const VideoImages: React.FC<VideoImagesProps> = ({
    images,
    video,
    content,
    link,
}) => {
    const responsiveInfo = useResponsive()
    return (
        <div>
            <Styles.Wrapper>
                {images.map((image, index) => (
                    <Styles.ImageWrapper key={index}>
                        <Image
                            src={image.url}
                            alt={image.alt}
                            css={{
                                objectFit: 'cover',
                                objectPosition: 'center',
                                width: '100%',
                                height: '100%',
                            }}
                        />
                    </Styles.ImageWrapper>
                ))}
                {responsiveInfo.lg && (
                    <Styles.VideoWrapper>
                        <video src={video} muted playsInline autoPlay loop />
                    </Styles.VideoWrapper>
                )}
                <Styles.Content>
                    <Title>
                        <RichText
                            htmlString={content}
                            css={{
                                fontWeight: 'normal',
                                em: { fontFamily: '$secondary' },
                            }}
                            //@ts-ignore
                            textVariant={{
                                '@initial': 'titleMedium',
                                '@lg': 'title',
                            }}
                        />
                    </Title>
                    {link && (
                        <Text
                            as={Link}
                            to={link.url}
                            textVariant="base"
                            textTransform="uppercase"
                        >
                            {link.title}
                        </Text>
                    )}
                </Styles.Content>
            </Styles.Wrapper>
        </div>
    )
}

export default VideoImages
